<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/banner-finantare_alt.png')"
          class="mx-auto"
          contain
          max-height="150px"
        ></v-img>
      </v-col>
    </v-row>

    <v-card class="pa-md-4 mx-auto" max-width="900px">
      <v-card-title>
        <h1 class="text-h4 text-center mb-3">Confirmare Email</h1>
      </v-card-title>
      <v-card-text>
        <v-alert type="warning" border="left" prominent text>
          Va rugam sa accesati linkul de confirmare pe care l-ati primit pe adresa <strong class="grey--text">{{ user.email }}</strong>.
          Daca nu ati primit mesajul apasati butonul de mai jos pentru retrimitere.
          Daca ati accesat linkul din email, va rugam reincarcati pagina apasand butonul de mai jos.
          <br>
          Inainte sa apasati butonul de retrimitere email, va rugam sa verificati sectiunea spam/bulk a clientului dumneavoastra de email.
          Din motive de securitate, aplicatia S.E.S. trimite doar un email intr-un interval de 10 minute.
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          large
          @click="refresh">
          Reincarcare pagina
        </v-btn>
        <v-btn
          large
          color="primary"
          @click="resendEmail"
          :disabled="loading"
          :loading="loading">
          Retrimite email
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import _throttle from "lodash.throttle";

export default {
  name: "not-verified",
  data: () => ({
    loading: false
  }),

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  methods: {
    resendEmail: _throttle(async function() {
      this.loading = true;
      await this.$store.dispatch("resendEmail");
      this.loading = false;
    }, 10 * 60 * 1000),
    refresh() {
      window.location.reload();
    }
  }
};
</script>
